/* Angular */
import { Injectable, Injector } from '@angular/core';

/* Rxjs */
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

/* Services */
import { BydAuthAbstractService } from '../shared/services/byd-auth-abstract.service';

/* Models */
import { BydResponseSso } from '../models/byd-response-sso';

/* Enums */
import { BydResponseSsoInterface } from '../interfaces/byd-response-sso.interface';
import { BydAuthApiPathsEnum } from '../enums/byd-auth-api-paths.enum';
import { BydAuthService } from './byd-auth.service';
import { BydLoginSso } from '../models/byd-login.sso';

@Injectable({
  providedIn: 'root',
})
export class BydAuthSsoService extends BydAuthAbstractService {
  /**
   * The abstract endpoint path.
   */
  public path: string;

  /**
   * Creates an instance of BydAuthService.
   *
   * @param injector creates a service injector instance
   * @param bydAuthService the beyond auth service
   */
  constructor(protected injector: Injector, private bydAuthService: BydAuthService) {
    super(injector);
  }

  /**
   * Login the user and get the token from response.
   *
   * @param login the user login
   * @param password the user password
   * @returns Observable<BydResponseSso>
   */
  public login(login: string): Observable<BydResponseSso> {
    this.path = BydAuthApiPathsEnum.AUTH_LOGIN_SSO;
    const body = new BydLoginSso({ login, scope: this.bydConfigService.injectedApiToken.apiScope });
    return this.postModel<BydResponseSso>({ body }).pipe(
      tap((response) => {
        if (response?.redirectUri) {
          this.bydAuthService.isLoggedIn = true;
        }
      })
    );
  }

  /**
   * Logout removes the current logged account & token.
   *
   * @returns Observable<BydResponseSso>
   */
  public logout(): Observable<BydResponseSso> {
    this.path = BydAuthApiPathsEnum.AUTH_LOGOUT_SSO;
    return this.getModel<BydResponseSso>();
  }

  /**
   * Creates an instance of BydResponseSso.
   *
   * @param bydResponseSso the azure response data.
   * @returns BydResponseSso
   */
  public createNewInstance(bydResponseSso: BydResponseSsoInterface): BydResponseSso {
    return new BydResponseSso(bydResponseSso);
  }
}
